<template>
  <redesign-base-icon
      :name="value ? 'CheckSquare' : 'X'"
      :class="{ 'text-success': value, 'text-destructive-actions' : !value }"
  />
</template>

<script setup lang="ts">
import RedesignBaseIcon from '@/components/RedesignBaseComponents/RedesignBaseIcon.vue'
defineProps<{ value: boolean }>()
</script>
